import { LoaderSvg, P2 } from '@zooplus/ui-components';

import { useTranslation } from '@hooks/use-translations';

import styles from './page-loader.module.scss';

const PageLoader = () => {
  const { t } = useTranslation();
  return (
    <div className={styles.container} data-testid="page-loader">
      <LoaderSvg variant="white" />
      <P2 className={styles.customText} bold={true}>
        {t('cart.loading.text')}
      </P2>
    </div>
  );
};

export default PageLoader;
